<template>
    <div class="language-switch control has-icons-left">
        <div class="select is-small" :class="{ 'is-light': isLight }">
            <select
                v-model="$i18n.locale"
                class="language-selector"
                :class="{ 'has-text-light': isLight }"
                @change="updateLanguage($i18n.locale)"
                @click.stop
            >
                <option
                    v-for="(o, i) in getLOCALES"
                    :key="i"
                    :value="o.value"
                    :selected="o.value === $i18n.locale.value"
                >
                    {{ o.caption }}
                </option>
            </select>
        </div>
        <div class="icon is-small is-left">
            <SvgIcon
                icon="icon--web-application_translate"
                grow-by-height
                :class="{ 'is-light': isLight, 'is-primary-dark': !isLight }"
                style="font-size: 1rem"
            />
        </div>
    </div>
</template>

<script>
import { LOCALES } from '../../i18n/locales';
import SvgIcon from '../svg/SvgIcon';
import { mapGetters } from 'vuex';

export default {
    name: 'LanguageSwitch',
    components: { SvgIcon },
    data() {
        return { getLOCALES: LOCALES };
    },
    computed: {
        ...mapGetters(['cmsPage']),
    },
    methods: {
        updateLanguage(lang) {
            let path = null;

            if (
                ['CMSView', 'CMSViewSubpage'].includes(this.$route.name) &&
                this.cmsPage
            ) {
                let language = this.cmsPage.languages.find(
                    (cmsLang) =>
                        cmsLang.locale === this.$i18n.locale.replace('-', '_')
                );

                if (!language) path = lang;
                else path = language.link.split('?')[0];
            } else {
                path = `${window.location.pathname}`;

                path = path
                    .replace(this.$route.params.lang + '/', '')
                    .replace(this.$route.params.lang, '');

                if (path[path.length - 1] === '/') {
                    path = path.substr(0, path.length - 1);
                }
            }

            if (path !== this.$route.path) this.$router.push({ path });
        },
    },
    props: {
        isLight: {
            required: false,
            default: false,
            type: Boolean,
        },
    },
};
</script>

<style lang="scss">
.control.has-icons-left.language-switch {
    .icon {
        top: 10%;
    }
}

.is-light {
    .language-switch .select select {
        background-color: $primary-light;
    }
}
</style>
